@if (team) {
    <adapt-catchups-page-content [team]="team"></adapt-catchups-page-content>
}
